function initAvGalleryModal() {
  var modal = document.querySelector('[data-av-gallery-modal]');
  if (!modal || modal.dataset.avGalleryModalInitialized) return;
  modal.dataset.avGalleryModalInitialized = 'true';

  var content = modal.querySelector('[data-av-gallery-modal-content]');
  var lastTrigger = null;

  function stopModalMedia() {
    content.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
    content.innerHTML = '';
  }

  function openModal(trigger) {
    var item = trigger.closest('.av-gallery__item');
    var template = item && item.querySelector('[data-av-gallery-content]');
    if (!template) return;

    stopModalMedia();
    content.appendChild(template.content.cloneNode(true));

    lastTrigger = trigger;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('[data-av-gallery-modal-close]').focus();

    waitForMedia(content.querySelector('img, video'));
  }

  function waitForMedia(media) {
    if (!media) {
      modal.classList.remove('is-loading');
      return;
    }

    modal.classList.add('is-loading');

    var stopLoading = function () {
      modal.classList.remove('is-loading');
    };

    if (media.tagName === 'IMG') {
      if (media.complete && media.naturalWidth > 0) {
        stopLoading();
      } else {
        media.addEventListener('load', stopLoading, { once: true });
        media.addEventListener('error', stopLoading, { once: true });
      }
    } else if (media.tagName === 'VIDEO') {
      if (media.readyState >= 3) {
        stopLoading();
      } else {
        media.addEventListener('loadeddata', stopLoading, { once: true });
        media.addEventListener('error', stopLoading, { once: true });
      }
    } else {
      stopLoading();
    }
  }

  function closeModal() {
    modal.hidden = true;
    modal.classList.remove('is-loading');
    document.body.style.overflow = '';
    stopModalMedia();
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-av-gallery-trigger]');
    if (trigger) {
      openModal(trigger);
      return;
    }

    // Close on the explicit close button, or when clicking the modal's own background
    // (i.e. anywhere that isn't the box/content/close button itself).
    if (event.target.closest('[data-av-gallery-modal-close]') || event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}

function initAvGalleryItemSpinners() {
  document.querySelectorAll('.av-gallery__item').forEach(function (item) {
    if (item.dataset.avGallerySpinnerBound) return;
    item.dataset.avGallerySpinnerBound = 'true';

    var media = item.querySelector('.av-gallery__media');
    if (!media) {
      item.classList.remove('is-loading');
      return;
    }

    var stopLoading = function () {
      item.classList.remove('is-loading');
    };

    if (media.tagName === 'IMG') {
      if (media.complete && media.naturalWidth > 0) {
        stopLoading();
      } else {
        media.addEventListener('load', stopLoading, { once: true });
        media.addEventListener('error', stopLoading, { once: true });
      }
    } else if (media.tagName === 'VIDEO') {
      if (media.readyState >= 3) {
        stopLoading();
      } else {
        media.addEventListener('loadeddata', stopLoading, { once: true });
        media.addEventListener('error', stopLoading, { once: true });
      }
    } else {
      stopLoading();
    }
  });
}

var avGalleryGrayscaleItems = [];
var avGalleryGrayscaleTicking = false;

function avGalleryUpdateGrayscale() {
  var viewportCenter = window.innerHeight / 2;

  avGalleryGrayscaleItems.forEach(function (item) {
    var rect = item.getBoundingClientRect();
    var itemCenter = rect.top + rect.height / 2;
    var distance = Math.abs(itemCenter - viewportCenter);
    var amount = Math.min(distance / viewportCenter, 1);
    item.style.setProperty('--av-gallery-grayscale-amount', amount.toFixed(3));
  });

  avGalleryGrayscaleTicking = false;
}

function avGalleryRequestGrayscaleUpdate() {
  if (avGalleryGrayscaleTicking) return;
  avGalleryGrayscaleTicking = true;
  window.requestAnimationFrame(avGalleryUpdateGrayscale);
}

function initAvGalleryGrayscaleReveal() {
  // Re-collect items fresh every call (editor may have added/removed galleries/images),
  // but only ever bind the scroll/resize listeners once globally.
  avGalleryGrayscaleItems = [];
  document.querySelectorAll('[data-av-gallery][data-grayscale-preview] .av-gallery__item').forEach(function (item) {
    avGalleryGrayscaleItems.push(item);
  });

  if (!avGalleryGrayscaleItems.length) return;

  avGalleryRequestGrayscaleUpdate();

  if (!window.__avGalleryGrayscaleBound) {
    window.__avGalleryGrayscaleBound = true;
    window.addEventListener('scroll', avGalleryRequestGrayscaleUpdate, { passive: true });
    window.addEventListener('resize', avGalleryRequestGrayscaleUpdate);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAvGalleryModal);
  document.addEventListener('DOMContentLoaded', initAvGalleryItemSpinners);
  document.addEventListener('DOMContentLoaded', initAvGalleryGrayscaleReveal);
} else {
  initAvGalleryModal();
  initAvGalleryItemSpinners();
  initAvGalleryGrayscaleReveal();
}

document.addEventListener('shopify:section:load', function () {
  initAvGalleryModal();
  initAvGalleryItemSpinners();
  initAvGalleryGrayscaleReveal();
});
